import { Frame } from 'features/Frames/types';
import { FIELDS_TO_SEARCH } from 'mocks/server/utils/constants';

export const framesBySearch = (searchTerm: string, frames: Frame[]) => {
  return frames.filter((frame) => {
    return FIELDS_TO_SEARCH.some(
      (field) => frame[field]?.toString().toLowerCase() === searchTerm.toLowerCase()
    );
  });
};
